{
	"description": "Entitlement Template for Jira Service Management (Cloud) Free",
	"features": []
}
